export default __webpack_public_path__ + "static/media/hexomatic-logo-rectangle-white.00c961bb.svg";